import { Component, EventEmitter, Input, OnInit, Output  } from '@angular/core';
import { Location } from '@angular/common';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
//import { ApiService } from '../services/api.service';
import { DataService } from '../data.service';
import { environment } from '../../environments/environment';

import { ActivatedRoute } from '@angular/router';
import * as Survey from "../survey.angularN.js";
import * as widgets from "surveyjs-widgets";
import { init as initCustomWidget } from "../customwidget";
import * as _ from 'lodash';
import { Observable } from 'rxjs';

widgets.icheck(Survey);
widgets.select2(Survey);
widgets.inputmask(Survey);
widgets.jquerybarrating(Survey);
widgets.jqueryuidatepicker(Survey);
widgets.nouislider(Survey);
widgets.select2tagbox(Survey);
//widgets.signaturepad(Survey);
widgets.sortablejs(Survey);
widgets.ckeditor(Survey);
widgets.autocomplete(Survey);
widgets.bootstrapslider(Survey);
widgets.prettycheckbox(Survey);

initCustomWidget(Survey);

Survey.JsonObject.metaData.addProperty("questionbase", "popupdescription:text");
Survey.JsonObject.metaData.addProperty("page", "popupdescription:text");

Survey.StylesManager.applyTheme("default");

@Component({
  selector: 'app-registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.css']
})



  export class RegistroComponent implements OnInit{
    title='encuesta';
    id;    
    formulario;
    respuestas;
    surveyJson;
    Nombre;
    Descripcion;
    grabaraudio;
    agregarsujeto;
    campoidentificador;
    campodescripcion;
    sololectura;
    rutaAPI: string = `${environment.API_URL}`;


    @Input() idsujeto: string | null = null; 
    @Input() idformulario: string | null = null;  
    @Input() idencuesta: string | null = null;  
    @Output() RegistroGuardado = new EventEmitter<void>();
  
    constructor( private data: DataService, private http: HttpClient, private route: ActivatedRoute, private location: Location) {

      (window as any).RUTA_API_GLOBAL = environment.API_URL;
      
      const myParam = this.route.snapshot.queryParamMap.get('myParam');
      console.log(myParam);
      // const queryParams = new URLSearchParams(location.search);
      // const myParam = queryParams.get('myParam');
      //this.id = this.route.snapshot.paramMap.get('id');
      this.id = 164;
      
      //this.id = _.get(this.route.snapshot.params, 'idencuesta',0); 
      //this.idsujeto = _.get(this.route.snapshot.params, 'idsujeto',0); 
      this.sololectura = _.get(this.route.snapshot.params, 'sololectura',0); 
      //this.idformulario = _.get(this.route.snapshot.params, 'id',0);


      console.log("this.id: ");
      console.log(this.id);

      console.log("this.idsujeto: ");
      console.log(this.idsujeto);

      


    }

    
    // getSujeto(): Observable<Object[]> { 
    //   var body = {
    //       "encuestaid": this.id,
    //       "id": this.idsujeto==''?null:this.idsujeto,
    //       "pagina": 1,
    //       "resultadosXpagina": 1
    //       }
    //   return this.apiService.post("/api/Sincronizador/resultadosweb", body);
    // }    
  
    ngOnInit(): void {

      


      const httpOptions = {
          headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      }

        this.data.ObtenerFormulario(this.idformulario).subscribe(async x => {
          console.log("==========================RESULTADO============================");
          console.log(x);
          console.log("id");
          console.log(this.id);

          this.formulario = x;
    
          this.surveyJson = this.formulario["Definicion"];
          this.Nombre = this.formulario["Definicion"]["title"];
          this.Descripcion = this.formulario["Definicion"]["description"];
    
          // this.grabaraudio = this.formulario["grabaraudio"];
          // this.agregarsujeto = this.formulario["agregarsujeto"] == 'True';
          this.campoidentificador = this.formulario["CampoIdentificador"];
          this.campodescripcion = this.formulario["CampoDescripcion"];

            
  
         const surveyModel = new Survey.Model(this.surveyJson);



         
      function fecha(params) {

        var formato = params[0];
        console.log(params);

        const fecha = new Date();

        let dia = fecha.getDate();
        let mes = fecha.getMonth() + 1;
        let anio = fecha.getFullYear();

        let dias;
        dias = dia < 10 ? '0' + dia : dia;

        let mess;
        mess = mes < 10 ? '0' + mes : mes;

        switch (formato) {
          case 1:
            return dia + '/' + mess + '/' + anio;
          case 2:
            return mess + '/' + dias + '/' + anio;
          case 3:
            return anio + '-' + mess + '-' + dia;
          case 4:
            return anio + mess + dia;
          default:
            return dias + '/' + mess + '/' + anio;
        }

      }

      function eliminarintegrantes(params) {

        var panel = params[0];
        console.log(params);


        console.log(surveyModel.data['integrante']);
        for (var elemento of surveyModel.data['integrante']) {
          console.log(elemento);
          if (elemento['Participa'] == false) {
            var index = surveyModel.data['integrante'].indexOf(elemento);
            var question = surveyModel.getQuestionByName(panel);
            console.log("question");
            console.log(question);
            console.log("Index:");
            console.log(index);
            question.allowRemoveRows = true;
            question.removeRow(index);
            question.allowRemoveRows = false;
          }
        }
        Survey.SurveyNG.render("surveyElement", { model: surveyModel });


      }

      function pasardatos(params) {

        console.log("SE ESTA EJECUTANDO pasardatos");
        var integrante = JSON.parse(params[0]);
        var campoescaner = params[1];
        var panel = params[2];
        var dpanel = params[3];
        var index = params[4];

        /*
        console.log("=================integrante====================");
        console.log(integrante);

        console.log("=================campoescaner====================");
        console.log(campoescaner);

        console.log("=================panel====================");
        console.log(panel);

        console.log("=================dpanel====================");
        console.log(dpanel);

        console.log("=================index====================");
        console.log(index);
*/

        if (integrante && integrante.NumeroDocumento != null) {

          /*
          console.log("=================FechaNacimiento inicial====================");
          console.log(integrante);
          */

          integrante.DiaNacimiento = integrante.DiaNacimiento < 10 ? '0' + integrante.DiaNacimiento : integrante.DiaNacimiento;
          integrante.MesNacimiento = integrante.MesNacimiento < 10 ? '0' + integrante.MesNacimiento : integrante.MesNacimiento;

          integrante.FechaNacimiento = integrante.AnoNacimiento + '-' + integrante.MesNacimiento + '-' + integrante.DiaNacimiento;

          /*
          console.log("=================FechaNacimiento====================");
          console.log(integrante.FechaNacimiento);
          */




          var contenedor;
          if (panel) {

            var dPanel = surveyModel.getQuestionByName(dpanel);
            /*
            console.log("=================dPanel====================");
            console.log(dPanel);
            */

            if (dPanel && dPanel.panels[index]) {
              contenedor = dPanel.panels[index];
              // console.log("======contenedor======");
              // console.log(contenedor);
              // console.log(contenedor.getQuestionByName(campoescaner));
              var pregunta = contenedor.getQuestionByName(campoescaner);
              // console.log(pregunta.CampoDocumento ? pregunta.CampoDocumento : "null");

              var pregunta = contenedor.getQuestionByName(campoescaner);
              var CampoDocumento = pregunta.CampoDocumento ? pregunta.CampoDocumento : null;
              var CampoPrimerNombre = pregunta.CampoPrimerNombre ? pregunta.CampoPrimerNombre : null;
              var CampoSegundoNombre = pregunta.CampoSegundoNombre ? pregunta.CampoSegundoNombre : null;
              var CampoPrimerApellido = pregunta.CampoPrimerApellido ? pregunta.CampoPrimerApellido : null;
              var CampoSegundoApellido = pregunta.CampoSegundoApellido ? pregunta.CampoSegundoApellido : null;
              var CampoNombreCompleto = pregunta.CampoNombreCompleto ? pregunta.CampoNombreCompleto : null;
              var CampoFechaNacimiento = pregunta.CampoFechaNacimiento ? pregunta.CampoFechaNacimiento : null;
              var CampoSexo = pregunta.CampoSexo ? pregunta.CampoSexo : null;
              var CampoTipoDeSangre = pregunta.CampoTipoDeSangre ? pregunta.CampoTipoDeSangre : null;



              if (CampoDocumento) contenedor.getQuestionByName(CampoDocumento).value = integrante.NumeroDocumento;
              if (CampoPrimerNombre) contenedor.getQuestionByName(CampoPrimerNombre).value = integrante.PrimerNombre;
              if (CampoSegundoNombre) contenedor.getQuestionByName(CampoSegundoNombre).value = integrante.SegundoNombre;
              if (CampoPrimerApellido) contenedor.getQuestionByName(CampoPrimerApellido).value = integrante.PrimerApellido;
              if (CampoSegundoApellido) contenedor.getQuestionByName(CampoSegundoApellido).value = integrante.SegundoApellido;
              if (CampoNombreCompleto) contenedor.getQuestionByName(CampoNombreCompleto).value = integrante.NombreCompleto;
              if (CampoFechaNacimiento) contenedor.getQuestionByName(CampoFechaNacimiento).value = integrante.FechaNacimiento;
              if (CampoSexo) contenedor.getQuestionByName(CampoSexo).value = integrante.IdGenero;
              if (CampoTipoDeSangre) contenedor.getQuestionByName(CampoTipoDeSangre).value = integrante.RH;

              // console.log("contenedor");
              // console.log(contenedor);
            }
          }
          else {
            contenedor = surveyModel;

            var pregunta = contenedor.getQuestionByName(campoescaner);
            // console.log("pregunta");
            // console.log(pregunta);
            var CampoDocumento = pregunta.CampoDocumento ? pregunta.CampoDocumento : null;
            var CampoPrimerNombre = pregunta.CampoPrimerNombre ? pregunta.CampoPrimerNombre : null;
            var CampoSegundoNombre = pregunta.CampoSegundoNombre ? pregunta.CampoSegundoNombre : null;
            var CampoSegundoNombre = pregunta.CampoSegundoNombre ? pregunta.CampoSegundoNombre : null;
            var CampoPrimerApellido = pregunta.CampoPrimerApellido ? pregunta.CampoPrimerApellido : null;
            var CampoSegundoApellido = pregunta.CampoSegundoApellido ? pregunta.CampoSegundoApellido : null;
            var CampoNombreCompleto = pregunta.CampoNombreCompleto ? pregunta.CampoNombreCompleto : null;
            var CampoFechaNacimiento = pregunta.CampoFechaNacimiento ? pregunta.CampoFechaNacimiento : null;
            var CampoSexo = pregunta.CampoSexo ? pregunta.CampoSexo : null;
            var CampoTipoDeSangre = pregunta.CampoTipoDeSangre ? pregunta.CampoTipoDeSangre : null;

            if (CampoDocumento) contenedor.setValue(CampoDocumento, integrante.NumeroDocumento);
            if (CampoPrimerNombre) contenedor.setValue(CampoPrimerNombre, integrante.PrimerNombre);
            if (CampoSegundoNombre) contenedor.setValue(CampoSegundoNombre, integrante.SegundoNombre);
            if (CampoPrimerApellido) contenedor.setValue(CampoPrimerApellido, integrante.PrimerApellido);
            if (CampoSegundoApellido) contenedor.setValue(CampoSegundoApellido, integrante.SegundoApellido);
            if (CampoNombreCompleto) contenedor.setValue(CampoNombreCompleto, integrante.NombreCompleto);
            if (CampoFechaNacimiento) contenedor.setValue(CampoFechaNacimiento, integrante.FechaNacimiento);
            if (CampoSexo) contenedor.setValue(CampoSexo, integrante.IdGenero);
            if (CampoTipoDeSangre) contenedor.getQuestionByName(CampoTipoDeSangre).value = integrante.RH;

          }

          //var CampoTieneDocumentoIdentidad = surveyModel.getQuestionByName(campoescaner).CampoTieneDocumentoIdentidad;
          //var CampoDiaNacimiento = surveyModel.getQuestionByName(campoescaner).CampoDiaNacimiento;
          //var CampoMesNacimiento = surveyModel.getQuestionByName(campoescaner).CampoMesNacimiento;
          //var CampoAnoNacimiento = surveyModel.getQuestionByName(campoescaner).CampoAnoNacimiento;
          //var CampoFechaExpedicionDocumento = surveyModel.getQuestionByName(campoescaner).CampoFechaExpedicionDocumento;
          //var CampoAnoExpedicion = surveyModel.getQuestionByName(campoescaner).CampoAnoExpedicion;
          //surveyModel.setValue(CampoTieneDocumentoIdentidad, integrante.NumeroDocumento);

        }

      }

      function existe(params) {
        var valor = params[0];
        var grupo = params[1];
        var pregunta = params[2];
        var panel = params[3];
        var panelindex = params[4];
        // console.log("?????????????????????????????????????????????????????????????????????????????????????");
        // console.log("?????????????????????????????????????????????????????????????????????????????????????");
        // console.log("?????????????????????????????????????????????????????????????????????????????????????");
        // console.log("?????????????????????????????????????????????????????????????????????????????????????");
        // console.log("?????????????????????????????????????????????????????????????????????????????????????");
        // console.log("?????????????????????????????????????????????????????????????????????????????????????");
        // console.log("?????????????????????????????????????????????????????????????????????????????????????");
        // console.log("?????????????????????????????????????????????????????????????????????????????????????");
        // console.log("?????????????????????????????????????????????????????????????????????????????????????");
        // console.log("?????????????????????????????????????????????????????????????????????????????????????");
        // console.log("?????????????????????????????????????????????????????????????????????????????????????");
        // console.log("valor:"+ valor);
        // console.log("panel:" + grupo);
        // console.log("pregunta:"+ pregunta);

        if (surveyModel.data[grupo]) {
          //console.log(surveyModel.data[grupo]);
          var cont = 0;
          for (var elemento of surveyModel.data[grupo]) {
            if (cont == panelindex) {
              cont++;
              continue;
            }
            if (elemento[pregunta] == valor) {
              return true;
            }
            else {
              cont++;

            }
          }
          return false;
        }
        else {
          //console.log("///////////////////////////////////////////////////////////////////////////////////");
          return false;
        }




      }


      function opciones(params) {

        var grupo = params[0];
        var dropdown = params[1];
        var texto = params[2];
        var nombrepanel = params[3];
        var indexdepregunta = params[4];
        var incluiractual = params[5];
        //imprimir en consola todas estas variables
        console.log("====================================================================================");
        console.log("====================================================================================");
        console.log("====================================================================================");
        console.log("====================================================================================");
        console.log("====================================================================================");
        console.log("====================================================================================");
        console.log("====================================================================================");
        console.log("====================================================================================");
        console.log("====================================================================================");
        console.log("====================================================================================");
        console.log("====================================================================================");
        console.log("====================================================================================");
        console.log("grupo:" + grupo);
        console.log("dropdown:" + dropdown);
        console.log("texto:" + texto);
        console.log("nombrepanel:" + nombrepanel);
        console.log("indexdepregunta:" + indexdepregunta);
        console.log("incluiractual:" + incluiractual);


        var pregunta;


        try {
          if (nombrepanel) {

            pregunta = surveyModel.getQuestionByName(nombrepanel);
            pregunta = pregunta.panels[indexdepregunta].getQuestionByName(dropdown);
          }
          else {
            pregunta = surveyModel.getQuestionByName(dropdown);
          }
          var valor = pregunta.value;

          if (surveyModel.data[grupo]) {
            //console.log(surveyModel.data[grupo]);
            var cont = 0;
            var opciones = [];

            for (var elemento of surveyModel.data[grupo]) {
              if (nombrepanel && (incluiractual == undefined || incluiractual == "false" || incluiractual == false)) {
                if (cont != indexdepregunta) {
                  var item = { value: cont, text: elemento[texto] };
                  opciones.push(item);
                }
              }
              else {
                var item = { value: cont, text: elemento[texto] };
                opciones.push(item);
              }
              cont++;
            }
            pregunta.choices = opciones;
            pregunta.value = valor;
            return true;
          }
          else {
            return false;
          }
        }
        catch (err) {
          console.log(err);
          return false;
        }





      }

      function pareja(params) {

        var grupo = params[0];
        var index = params[1];
        var campoedad = params[2];
        var edadminima = params[3];


        if (index != null) {

          try {
            //imprimir grupo
            console.log("grupo:" + grupo);
            console.log("index:" + index);
            console.log("campoedad:" + campoedad);
            console.log("edadminima:" + edadminima);
            var edad = surveyModel.data[grupo][index][campoedad];
            if (edad >= edadminima) {
              console.log("Valido");
              return true;
            }
            else {
              console.log("Inválido");
              return false;
            }
          }
          catch (err) {
            console.log(err);
            return false;
          }

        }
        else {
          return true;
        }


      }

      function distancia(params) {

        var p1 = params[0];
        var p2 = params[1];

        if (p1 != null && p2 != null) {
          var punto1 = p1.split(",");
          var punto2 = p2.split(",");
          var lat1 = punto1[0];
          var lon1 = punto1[1];
          var lat2 = punto2[0];
          var lon2 = punto2[1];

          const radioTierra = 6378.1; // Radio de la Tierra en km
          const dLat = (lat2 - lat1) * Math.PI / 180;
          const dLon = (lon2 - lon1) * Math.PI / 180;
          const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
          const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
          const distancia = radioTierra * c * 1000; // Distancia en metros
          return distancia;
        }
        else {
          return null;
        }



      }

      function longitud(params) {
        var p1 = params[0];
        if(p1 != null && p1 != undefined && p1 != "")
        {
                  console.log(p1);
        var cadena = p1.toString();

        if (cadena != null && cadena != "" && cadena != undefined) {
          return cadena.length;
        }
        else {
          return 0;
        }
        }
        else
        {
          return 0;
        }

      }
    
    Survey.FunctionFactory.Instance.register("pasardatos", pasardatos, true);
    Survey.FunctionFactory.Instance.register("existe", existe);
    Survey.FunctionFactory.Instance.register("opciones", opciones);
    Survey.FunctionFactory.Instance.register("pareja", pareja);
    Survey.FunctionFactory.Instance.register("distancia", distancia);
    Survey.FunctionFactory.Instance.register("eliminarintegrantes", eliminarintegrantes);
    Survey.FunctionFactory.Instance.register("fecha", fecha);
    Survey.FunctionFactory.Instance.register("longitud", longitud);


    if(this.idsujeto)
    {
        this.data.ObtenerRegistro(this.idsujeto).subscribe(resultado => {
          this.respuestas = resultado['Respuestas'];   
          this.ConfigurarRespuestas(this.respuestas);    
          console.log("=======respuestas========");
          console.log(this.respuestas);


          

          const fileQuestions = surveyModel.getAllQuestions().filter(q => q.getType() === "file");
          console.log("=======fileQuestions========");
          console.log(fileQuestions);


          if(fileQuestions.length > 0){
            fileQuestions.forEach(q => {
              console.log("Nombre de la pregunta:", q.name);
              console.log("Valor actual:", q.value);
              var rarchivo=this.respuestas[q.name];
              if(rarchivo){
                rarchivo.forEach(element => {
                  element.content = this.rutaAPI+"Portal_Archivo?archivo="+this.idencuesta+"/"+element.content;
                });
              }

  
            });
          }


          console.log("=======this.respuestas========");
          console.log(this.respuestas);

          surveyModel.data = this.respuestas;


          if(this.sololectura!=0){
            surveyModel.mode = 'display';
          }
        
           Survey.SurveyNG.render("surveyContainer", { model: surveyModel });
            surveyModel.clearInvisibleValues = "none"; // "onHidden", "onComplete", "none"
            surveyModel.showInvisibleElements = true;
    
            surveyModel.onComplete.add(async (result, options) => {
    
    
              //alert(JSON.stringify(result.data));
              var respuestas = result.data;
              console.log("**************************************************************");
              console.log("**************************************************************");
              console.log("**************************************************************");
              console.log("**************************************************************");
              console.log("**************************************************************");
              console.log("**************************************************************");
              console.log("**************************************************************");
              console.log("**************************************************************");
              console.log("**************************************************************");
              console.log("**************************************************************");
              console.log("**************************************************************");
              console.log("**************************************************************");

              const fileQuestions = surveyModel.getAllQuestions().filter(q => q.getType() === "file");
              console.log("=======fileQuestions========");
              console.log(fileQuestions);
    
    
              if(fileQuestions.length > 0){
                fileQuestions.forEach(q => {
                  console.log("Nombre de la pregunta:", q.name);
                  console.log("Valor actual:", q.value);
                  var rarchivo=this.respuestas[q.name];
                  if(rarchivo){
                    rarchivo.forEach(element => {
                      //quitar de element.content this.rutaAPI+"Portal_Archivo?archivo="+this.idencuesat+"/"
                      console.log("1**************************************************************");
                      console.log("**************************************************************");
                      console.log("**************************************************************");
                      console.log("**************************************************************");
                      console.log("**************************************************************");
                      console.log("**************************************************************");
                      console.log("**************************************************************");
                      console.log("**************************************************************");
                      console.log("**************************************************************");
                      console.log("**************************************************************");
                      console.log("**************************************************************");
                      console.log("**************************************************************");
                      element.content = element.content.replace(this.rutaAPI+"Portal_Archivo?archivo="+ this.idencuesta+"/", "");
                    });
                  }
    
      
                });
              }
    
              var sujeto = {
                _id: this.idsujeto,
                HoraFinaliza: (new Date()).toLocaleString('es-co'),
                IdEncuesta: this.idencuesta,
                Identificacion: respuestas[this.campoidentificador],
                Respuestas: respuestas
            };
    

              console.log("=====================Registro a guardar=====================");
              console.log(sujeto);
              
              this.data.GuardarRegistro(sujeto).subscribe((result) => {
                this.RegistroGuardado.emit();

              });

    
          });

        });   
    }
    else{

      this.respuestas = {};   
          this.ConfigurarRespuestas(this.respuestas);    
          console.log("=======respuestas========");
          console.log(this.respuestas);


          surveyModel.data = this.respuestas;
          if(this.sololectura!=0){
            surveyModel.mode = 'display';
          }
        
           Survey.SurveyNG.render("surveyContainer", { model: surveyModel });
    
            surveyModel.onComplete.add(async (result, options) => {
    
    
              console.log("2**************************************************************");
              console.log("**************************************************************");
              console.log("**************************************************************");
              console.log("**************************************************************");
              console.log("**************************************************************");
              console.log("**************************************************************");
              console.log("**************************************************************");
              console.log("**************************************************************");
              console.log("**************************************************************");
              console.log("**************************************************************");
              console.log("**************************************************************");
              console.log("**************************************************************");

              //alert(JSON.stringify(result.data));
              var respuestas = result.data;
    
              var sujeto = {
                  HoraFinaliza: (new Date()).toLocaleString('es-co'),
                  IdEncuesta: this.idencuesta,
                  Identificacion: respuestas[this.campoidentificador],
                  Respuestas: respuestas
              };

              console.log("=====================Registro a guardar=====================");
              console.log(sujeto);
                  
              this.data.GuardarRegistro(sujeto).subscribe((result) => {
                this.RegistroGuardado.emit();
              });
    
          });


    }     
  });


  
      
  
  
  
    }

    ConfigurarRespuestas(respuestas) {
      console.log("ConfigurarRespuestas");
    }
  }


